import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";
import useAuthStore from "./useAuthStore";
import Base64e from "../components/encodedecode/encode";
import { useMatchStore } from "./useMatchStore";

interface SendLikeState {
  loadinglike: boolean;
  success: boolean;
  error: string;

  sendLike: (
    otherUserId: number,
    priority: number,
    msg: string,
    requestId: string
  ) => Promise<boolean>;

  sendDiamond: (
    otherUserId: number,
    requestId?: string
  ) => Promise<boolean>;
}

export const useSendLikeStore = create<SendLikeState>((set) => ({
  loadinglike: false,
  success: false,
  error: "",

  // --------------------------------------------------
  // ❤️ NORMAL LIKE / MATCH
  // --------------------------------------------------
  sendLike: async (otherUserId, priority, msg, requestId) => {
    set({ loadinglike: true, success: false, error: "" });

    try {
      const authStore = useAuthStore.getState();
      const user = authStore.user;

      if (!user) {
        set({ loadinglike: false, error: "User not authenticated." });
        return false;
      }

      const requestData = {
        from: Base64e.encode(user.id + ""),
        to: Base64e.encode(otherUserId + ""),
        priority,
        msg,
        id: requestId || "",
        column: requestId ? "to_priority" : "priority",
        status: requestId ? 1 : 0,
        is_diamond: false, // ❤️ NORMAL
      };

      const response = await axiosInstance.post(
        "sendUserRequests",
        requestData
      );

      if (response.status === 200) {
        useMatchStore.getState().getMatch(0);

        set({ loadinglike: false, success: true });
        return true;
      } else if (response.status === 403) {
        set({ loadinglike: false, error: "Daily like limit reached." });
        return false;
      } else {
        set({
          loadinglike: false,
          success: false,
          error: "Failed to send request.",
        });
        return false;
      }
    } catch (error) {
      console.error("Error sending like:", error);
      set({
        loadinglike: false,
        success: false,
        error: "Something went wrong.",
      });
      return false;
    }
  },

  // --------------------------------------------------
  // 💎 DIAMOND SEND
  // --------------------------------------------------
  sendDiamond: async (otherUserId, requestId = "") => {
    set({ loadinglike: true, success: false, error: "" });

    try {
      const authStore = useAuthStore.getState();
      const user = authStore.user;

      if (!user) {
        set({ loadinglike: false, error: "User not authenticated." });
        return false;
      }

      const requestData = {
        from: Base64e.encode(user.id + ""),
        to: Base64e.encode(otherUserId + ""),
        priority: 100, // 💎 high base
        msg: "",
        id: requestId,
        column: requestId ? "to_priority" : "priority",
        status: requestId ? 1 : 0,
        is_diamond: true, // 💎 KEY FLAG
      };

      const response = await axiosInstance.post(
        "sendUserRequests",
        requestData
      );

      if (response.status === 200) {
        useMatchStore.getState().getMatch(0);

        set({ loadinglike: false, success: true });
        return true;
      } else if (response.status === 403) {
        set({
          loadinglike: false,
          error: "Diamond limit reached for today.",
        });
        return false;
      } else {
        set({
          loadinglike: false,
          success: false,
          error: "Failed to send diamond.",
        });
        return false;
      }
    } catch (error) {
      console.error("Diamond error:", error);
      set({
        loadinglike: false,
        success: false,
        error: "Something went wrong.",
      });
      return false;
    }
  },
}));